export enum CoatingObjectEnum {
  PRODUCT = 0,
  SYSTEM = 1,
  SOLUTION = 2,
  COAT = 3,
}
